import { keyBy } from 'lodash';
import i18next from 'i18next';

import { ENTITY_UNITS } from '@commons/constants/units';

export const formatEntityWithChannels = (composition, clientChannels) => {
  const { entity, quantity, channels } = composition;

  const formattedEntity = {
    ...entity,
    __entityId: entity.__entityId || entity.id,
    quantity,
    cost: entity.isIngredient ? entity.cost : null,
    unit:
      entity.unit === ENTITY_UNITS.UNIT
        ? i18next.t('ORDERS.ORDERS.EXPORT_LABEL_UNIT')
        : entity.unit,
    category: entity.isIngredient ? i18next.t('GENERAL.INGREDIENT') : entity.category,
    channels: {},
  };

  clientChannels.forEach((clientChannel) => {
    formattedEntity.channels[clientChannel.id] = channels.some(({ id }) => id === clientChannel.id);
  });

  return formattedEntity;
};

export const buildFormFieldsFromComposition = (composition, clientChannels) =>
  composition.map(({ entity, quantity, channelIds = [] }) =>
    formatEntityWithChannels(
      { entity, quantity, channels: channelIds.map((id) => ({ id })) },
      clientChannels,
    ),
  );

export const formatCompositions = (entities, compositions, clientChannels) => {
  const compositionsByEntityId = keyBy(compositions, ({ entity }) => entity?.id);

  return entities.map((entity) => {
    const channelIds = [];

    clientChannels.forEach((clientChannel) => {
      if (entity.channels[clientChannel.id]) {
        channelIds.push(clientChannel.id);
      }
    });

    const composition = compositionsByEntityId[entity.id];

    const compositionAllergens = composition ? composition.allergens : [];

    return {
      entity,
      channelIds,
      quantity: entity.quantity,
      cost: entity.isIngredient ? entity.cost : null,
      allergens: entity.allergens || compositionAllergens,
    };
  });
};
